import React from "react";
import "./landing.css";

/* This is a genuine sequence — an order really does pass through these six
   stages in this order — so the numbering carries information. */
const STEPS = [
  {
    title: "Log in",
    body: "Your chef or purchasing manager signs in to the app with the account we set up for your business.",
    icon: <LogInIcon />,
  },
  {
    title: "Pick your produce",
    body: "Browse the fruit and vegetables available, see the day's prices, and set the quantities you need.",
    icon: <BasketIcon />,
  },
  {
    title: "Send the order",
    body: "Submit it in a couple of taps. It lands with our team straight away.",
    icon: <SendIcon />,
  },
  {
    title: "We review it",
    body: "We check the order against what is on the floor, adjust anything that has changed, and send it back to you.",
    icon: <ReviewIcon />,
  },
  {
    title: "You approve",
    body: "Confirm the final order — quantities, substitutions and price — before anything is packed.",
    icon: <CheckIcon />,
  },
  {
    title: "We deliver",
    body: "The order goes to our delivery team and arrives at the time of day that suits your kitchen.",
    icon: <DeliveryIcon />,
  },
];

export default function HowItWorks() {
  return (
    <section className="tfm-section tfm-section--recessed" id="howtoorder">
      <div className="tfm-container">
        <div className="tfm-section-head">
          <p className="tfm-eyebrow">How to order</p>
          <h2 className="tfm-h2" style={{ marginTop: "1.1rem" }}>
            From your kitchen to our crates, in six steps.
          </h2>
          <p className="tfm-lede">
            Nothing is packed until you have approved it. That is the whole
            point of the review step.
          </p>
        </div>

        <ol className="tfm-steps">
          {STEPS.map((step, index) => (
            <li className="tfm-step" key={step.title}>
              <p className="tfm-step__no tfm-mono">
                <span>{String(index + 1).padStart(2, "0")}</span>
                Step
              </p>
              <div className="tfm-step__icon">{step.icon}</div>
              <h3 className="tfm-step__title">{step.title}</h3>
              <p className="tfm-step__body">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

const stroke = {
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none",
};

function LogInIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" {...stroke} />
      <path d="m10 17 5-5-5-5M15 12H3" {...stroke} />
    </svg>
  );
}

function BasketIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 9h18l-1.2 10.1a2 2 0 0 1-2 1.9H6.2a2 2 0 0 1-2-1.9L3 9Z" {...stroke} />
      <path d="M8 9V7a4 4 0 0 1 8 0v2M9 13v4M15 13v4" {...stroke} />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M21 3 10.5 13.5M21 3l-6.8 18-3.7-7.5L3 9.8 21 3Z" {...stroke} />
    </svg>
  );
}

function ReviewIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5" {...stroke} />
      <path d="M13 3l5 5h-5V3ZM8 9h2M8 13h5" {...stroke} />
      <circle cx="17" cy="16" r="3.2" {...stroke} />
      <path d="m19.4 18.4 2.1 2.1" {...stroke} />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" {...stroke} />
      <path d="m8.5 12 2.5 2.5 4.5-5" {...stroke} />
    </svg>
  );
}

function DeliveryIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 6h11v11H3zM14 10h4l3 4v3h-7" {...stroke} />
      <circle cx="7.5" cy="17.5" r="1.8" {...stroke} />
      <circle cx="17.5" cy="17.5" r="1.8" {...stroke} />
    </svg>
  );
}
